/**
 * Copyright 2022 Design Barn Inc.
 */

import { DotlottiePlugin } from '@lottiefiles/toolkit-plugin-dotlottie';

export const dotLottiePlugin = new DotlottiePlugin();
